/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type GCPBucketLocationType = 'region' | 'dual-region' | 'multi-region';

export const GCPBucketLocationType = {

    REGION: 'region' as GCPBucketLocationType,

    DUAL_REGION: 'dual-region' as GCPBucketLocationType,

    MULTI_REGION: 'multi-region' as GCPBucketLocationType
};

